import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from 'src/app/Services/loader.service';

import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from './../../../../../Services/excel.service';

import { Observable } from 'rxjs';
import { StorageService } from 'src/app/Services/storage.service';
import { S3BudgetService } from 'src/app/Services/s3Budget.service';

@Component({
  selector: 'app-productivity-reports',
  templateUrl: './productivity-reports.component.html',
  styleUrls: ['./productivity-reports.component.css']
})
export class ProductivityComponent implements OnInit {

  public formFilters: any = FormGroup;

  public myDate = new Date();
  public maxDate: any;
  public objectKeys = Object.keys;
  public processedData: any = {};

  public enableAllOption:boolean = false;
  public multiSelectVehicle:boolean = false;

  public localStorage;
  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService,
    public storage: StorageService,
    public s2Service: S3BudgetService
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    // this.localStorage;
    this.localStorage = this.storage.get('vendorID_orgID');

    this.getRegNos();
    this.getVehicleDetails();
  }

  public vehicleRegNos: any
  public showTable: boolean;
  public vehicles;

  public startDateError: boolean;
  public allVehDownload: boolean;
  public tableData: any = [];
  public excelData: any = {};
  
  public cols = [
    { key: '#', display: '#' },
    { key: 'date', display: 'Date' },
    { key: 'timeDuration', display: 'Movement duration (in HH:MM:SS)', headerConfig:{ isDefault: true}},
    { key: 'dist', display: 'Distance travelled (km)' ,headerConfig:{ isDefault: true}},
    { key: 'maxSpeed', display: 'Max speed (km/h)' ,headerConfig:{ isDefault: true}}
  ];
  public noDataFoundEnable:boolean = false;

  getVehicleDetails() {

    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
        // console.log('vehicle ',this.vehicles);
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  filteredOptions: Observable<any[]>;
  selectedValues = [];

  ngOnInit(): void {
  }

  getRegNos() {

    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  async getVehicleEncryptRegNo(regNo) {
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }

  
  async submitForm(obj: any) {
    console.log(obj);
    try {
      if (obj) {
        let filterValues = obj.formFilds;
        this.vehicles = obj.vehicles;
        this.allVehDownload = false;
        this.showTable = true;
        this.tableData = [];
        this.showTable = false;
        this.noDataFoundEnable = false;
        this.loader.show();
        const vehicle = filterValues.selectedVehicle;
        const startDate = new Date(filterValues.sDate + '');
        //const endDate = new Date(new Date(filterValues.eDate + '').setHours(23,59,59));
        const endDate = new Date(new Date(filterValues.sDate + '').setHours(23,59,59));

        const arr: any = []
        let getDaysArray: any = function (start, end) {
          for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            const date = new Date(dt);
            arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
          }
          return arr;
        };
        const pad = (num) => {
          return num > 9 ? num : '0' + num;
        };

        const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
        const end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate());
        let daylist: any = getDaysArray(new Date(start), new Date(end));
        
        let vehLen = [];
        if(!Array.isArray(filterValues.selectedVehicle)) vehLen = [filterValues.selectedVehicle];
        else vehLen = filterValues.selectedVehicle;

        daylist = [...new Set(daylist)];
        const checkCurrentDay = (date) => {
          var inputDate = new Date(date);
          // Get today's date
          var todaysDate = new Date();
          // call setHours to take the time out of the comparison
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
          else return false;
        };
        let vehRegString = '';
        for (let veh = 0; veh < vehLen.length; veh++) {
          vehRegString = vehRegString+','+vehLen[veh];
        }

        let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehRegString).catch((e) => { console.log('unable to veh reg no'); })

        for (let veh = 0; veh < vehLen.length; veh++) {
          let exlData=[];
          let pdata: any=[],excel=[];
          if(vehLen[veh]!=undefined){
            if (this.processedData[vehLen[veh]] == undefined) { this.processedData[vehLen[veh]] = {}; }
            for (let day = 0; day < daylist.length; day++) {  
              let checkDay = checkCurrentDay(daylist[day]);

              if (this.processedData[vehLen[veh]][daylist[day]] == undefined) this.processedData[vehLen[veh]][daylist[day]] = {};
              if (!checkDay) {             
                this.loader.show();

                if (vehRegEncryKey[vehLen[veh]] != null) {
                  const splitDate = daylist[day].split('/');
                  const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
                  const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
                  const res = await this.api.readS3Data(url).catch((e)=>{});
                  if (JSON.stringify(res) != '{}' && res!==undefined && res!=null && res!='') {
                    
                    let tempData:any = await this.processData(res);
                    excel = [...excel,...tempData['xldata']];
                    this.loader.hide();
                  } else {
                    let tempData: any = { "data": [
                          {
                              "date": this.convertDateString(daylist[day]),
                              "dist": "---",
                              "timeDuration": "00:00:00",
                              "maxSpeed": "---"
                          }
                      ],
                      "xldata": [
                          {
                              "value": [
                                  this.convertDateString(daylist[day]),
                                  "00:00:00",
                                  "---",
                                  "---"
                              ]
                          }
                      ]
                  }

                    excel = [...excel, ...tempData['xldata']];
                    
                    let resValue = {
                      date: this.convertDateString(daylist[day]),
                      dist: '---',
                      timeDuration: '---',
                      maxSpeed: '---'
                    }
                    this.tableData.push(resValue)
                  }
                }
              }
            else{
              this.loader.show();
              let obj = {
                vehRegNo: vehLen[veh],
                date: new Date().setHours(0, 0, 0)
              };
              if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
              let getData = await this.comService.currentDayTrackingData(obj).catch((e) => {console.log('Unable to get current day data.'); });
              let tempData:any = await this.processData(getData);
              excel = [...excel,...tempData['xldata']];
              this.loader.hide();
            }
            }
            if(excel.length>0){


            let rowCount = 2;
            let endCell = 'E';
            let customizedData = [];
            let titleRow = {
              value: ['Productivity Report'],
              font: {
                name: 'Corbel', family: 4, size: 16, bold: true,
                color: { argb: 'FFFFFFFF' },

              },
              mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
              alignment: {
                cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
              },
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '966462AF' },
                bgColor: { argb: '966462AF' }
              },
            }

            customizedData.push(titleRow);

            rowCount = rowCount + 3;

            let subtitleRow = {
              value: [
                "Vehicle            : " + String(vehLen[veh]).toUpperCase() + "\n" +
                "Start Date       : " + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                "End Date         : " + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
              ],
              font: { name: 'Corbel', family: 4, size: 12, },
              mergeCells: `A${(rowCount - 2) + ''}:${endCell + rowCount + ''}`,
            }

            customizedData.push(subtitleRow);
            rowCount = rowCount + 1;
            let headerRow =
            {
              value: (vehicle=='ALL') ? ['S No', 'Vehicle', 'Date','Total distance','Movement duration',] : ['S No', 'Date','Time duration','Total distance','Maximum speed'],
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
              },
              font: { bold: true },
              border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            }
            customizedData.push(headerRow);

            let sNo = 1;
            excel = excel.map((item) => {
              item['value'] = [sNo, ...item['value']];
              sNo++;
              return item;
            })

            customizedData.push(...excel);

              // let sNo = 1;
              // excel = excel.map((item)=>{
              //   item = [sNo,...item];
              //   sNo++;
              //   return item;
              // })
              // const excelInfo = {
              //   title: {
              //     title: 'Productivity Report',
              //     subTitleRow: 'Date : ' + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY H:M:S') + ' to ' + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY H:M:S') ,
              //     font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
              //     mergeCells: 'A1:G2',
              //   },
              //   header: {
              //     headers: (vehicle=='ALL') ? ['S.No', 'Vehicle', 'Date','Total Distance','Movement Duration',] : ['S.No', 'Date','Time Duration','Total Distance','Maximum Speed'],
              //     fill: {
              //       type: 'pattern',
              //       pattern: 'solid',
              //       fgColor: { argb: 'FFFFFF00' },
              //       bgColor: { argb: 'FF0000FF' }
              //     },
              //     border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              //   },
              //   data: {
              //     data: excel,
              //     columWith: [{ colNo: 1, width: 20 }, { colNo: 2, width: 20 }, { colNo: 3, width: 40 }, { colNo: 4, width: 20 }, { colNo: 5, width: 40 }]
              //   }
              // };
              if (this.excelData[vehLen[veh]] == undefined) { this.excelData[vehLen[veh]] = {}; }
              this.excelData[vehLen[veh]] = {
                customizedData: customizedData,
                data: {
                  columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 40 }, { colNo: 4, width: 20 }, { colNo: 5, width: 20 }]
                }
              };
              //excelInfo;
            }
        }

        if (vehicle != 'ALL') {
/*           this.tableData.sort(function (x, y) {
            return x.gpsts - y.gpsts;
          }); */
          this.showTable = true;
        } else { this.allVehDownload = true; }
        this.noDataFoundEnable = true;
        this.loader.hide();

        }
      }
      else  this.loader.hide();

    }catch (error) {
      console.log(error);
    }
  }

  processData(data: any) {
    return new Promise((resolve, reject) => {
      try {
        const procesedData: any = [];
        let timeDuration = 0;
        const speedLimit = 5;//((speed == undefined) || (speed == null) || (speed == '')) ? 5 : speed;
        const sortingData = {};
        if(data && data.length > 0){
        data.map((item) => {
          // item.speed = 44;
          try{
            item.date = this.comService.timestampToDate(item.gpsts, 'DMY');
          if (item.gpsts !== undefined) {
            sortingData[item.gpsts] = item;
          }
          }catch(ex){
          }
          
        });
      }
      else{
        this.noDataFoundEnable = true; 
      }
        let totalDis: any = 0;
        const objKeys = this.objectKeys(sortingData);
        let maxSpeed=0;
        let time:any = '00:00:00';
        if (objKeys && objKeys.length) {

          const temp: any = [];let tempEx = [];
          for (let i = 0; i < objKeys.length; i++) {
            let prevKey = null, next = null, currentKey = objKeys[i], pre = null;
            if (i > 0) { prevKey = procesedData[procesedData.length - 1]; }
            if (objKeys[i + 1]) { next = objKeys[i + 1]; }
            let curdis = 0;
            if (i > 0) {
              pre = objKeys[i - 1];
              const lat1 = parseFloat(sortingData[currentKey].lat);
              const lat2 = parseFloat(sortingData[pre].lat);
              const lng1 = parseFloat(sortingData[currentKey].lng);
              const lng2 = parseFloat(sortingData[pre].lng);
              if ((lat1 == lat2) && (lng1 == lng2)) { curdis = 0; } else {
                const radlat1 = Math.PI * lat1 / 180.0;
                const radlat2 = Math.PI * lat2 / 180.0;
                const theta = lng1 - lng2;
                const radtheta = Math.PI * theta / 180.0;
                let dist: any = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                  dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                dist = (dist * 1.609344);
                curdis = parseFloat(dist);
              }
              if(sortingData[pre].spd && sortingData[currentKey].spd){
                if(Number(sortingData[pre].spd) > 5 && Number(sortingData[currentKey].spd) > 5)
                {
                  let timeValue = this.comService.timeDiff(sortingData[pre].gpsts,sortingData[currentKey].gpsts);
                  timeDuration = timeValue.seconds ? (timeDuration + timeValue.seconds) : (timeDuration + 0) ;
                  let seconds = Math.floor(timeDuration);
                  let minute = Math.floor(seconds / 60);
                  seconds = seconds % 60;
                  let hour = Math.floor(minute / 60);
                  minute = minute % 60;
                  time = (('' + hour).length == 1 ? '0' + hour : hour )+':'+(('' + minute).length == 1 ? '0' + minute : minute )+':'+(('' + seconds).length == 1 ? '0' + seconds : seconds );
                }
              }
            }
            totalDis = parseFloat(totalDis) + curdis;         

            if(Number(sortingData[currentKey].spd) > maxSpeed) maxSpeed = +sortingData[currentKey].spd;
            let resValue = {
              date: sortingData[currentKey].date,
              dist: totalDis.toFixed(2),
              timeDuration: time,
              maxSpeed: maxSpeed
            }
            
            if ((objKeys.length - 1) == i) {
              const rowVal = {
                value: [sortingData[currentKey].date,time,totalDis.toFixed(2),maxSpeed]
              };
              this.tableData.push(resValue);
              tempEx.push(rowVal);
              temp.push(resValue);
              const tdata = JSON.parse(JSON.stringify(resValue));
              procesedData.push(tdata);
              this.loader.show();

              resolve({ data: procesedData, xldata: tempEx });
            }
          }
        } else {
          resolve({ data:[], xldata: []});
        }

      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }
  async downloadAllVehicle() {
    const chunk: any = await this.comService.chunkObject(this.excelData, 50);

    for (let i = 0; i < chunk.length; i++) {
      this.excel.generateExcel(chunk[i], 'Productivity_Report_' + i + '_' + new Date().getTime() + '.xlsx');
    }

  }
  downloadXL() {
    this.excel.generateExcel(this.excelData, 'Productivity_Report_' + new Date().getTime() + '.xlsx');
  }
  convertDateString(dateString) {
    const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
    if (!dateFormatRegex.test(dateString)) {
      return dateString;
    }else{
    const date = new Date(dateString);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();
  
    // Return the formatted date string
    return `${day}/${month}/${year}`;
  }
}

}
